import { qs, qsa } from "../utils/dom"

export function initProfileImageGenerator() {
  for (const wrap of qsa(".profgen")) {
    const settings = JSON.parse(qs("script", wrap).textContent)

    const canvas = qs("canvas", wrap)
    const ctx = canvas.getContext("2d")

    const overlay = new Image()
    overlay.src = settings.overlay

    const download = qs(".profgen__download", wrap)

    qs("input", wrap).addEventListener("change", (e) => {
      const files = e.target.files
      if (files.length) {
        const url = URL.createObjectURL(files[0])
        const image = new Image()
        image.addEventListener("load", () => {
          ctx.clearRect(0, 0, canvas.width, canvas.height)

          const w = image.width
          const h = image.height
          const sideLength = Math.min(w, h)
          const x = Math.floor(w / 2 - sideLength / 2)
          const y = Math.floor(h / 2 - sideLength / 2)

          ctx.drawImage(
            image,
            x,
            y,
            sideLength,
            sideLength,
            0,
            0,
            canvas.width,
            canvas.width,
          )
          URL.revokeObjectURL(url)
          ctx.globalCompositeOperation = "soft-light"
          ctx.fillStyle = settings.tint
          ctx.fillRect(0, 0, canvas.width, canvas.width)
          ctx.globalCompositeOperation = "source-over"
          ctx.drawImage(
            overlay,
            0,
            0,
            overlay.width,
            overlay.height,
            0,
            0,
            canvas.width,
            canvas.width,
          )

          canvas.classList.remove("hide")
          download.classList.remove("hide")
        })
        image.src = url
      }
    })

    download.addEventListener("click", (e) => {
      e.preventDefault()

      canvas.toBlob((blob) => {
        const a = document.createElement("a")
        a.download = "profile.png"
        a.href = URL.createObjectURL(blob)
        a.click()
      }, "image/png")
    })
  }
}
